import { render, staticRenderFns } from "./uploadDeviceList.vue?vue&type=template&id=28a64afc&scoped=true&"
import script from "./uploadDeviceList.vue?vue&type=script&lang=js&"
export * from "./uploadDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./uploadDeviceList.vue?vue&type=style&index=0&id=28a64afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a64afc",
  null
  
)

export default component.exports